import { render, staticRenderFns } from "./Merchandises.vue?vue&type=template&id=2975d834&scoped=true&"
import script from "./Merchandises.vue?vue&type=script&lang=js&"
export * from "./Merchandises.vue?vue&type=script&lang=js&"
import style0 from "./Merchandises.vue?vue&type=style&index=0&id=2975d834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2975d834",
  null
  
)

export default component.exports